import React from 'react';

/**
 * JustifiedGrid - Google Photos-style justified row layout.
 * Items fill rows at a target height, with widths determined by aspect ratio.
 */
const JustifiedGrid = ({
  items = [],
  renderItem,
  getAspectRatio = () => 1,
  targetRowHeight = 200,
  gap = 6,
  className = '',
  keyExtractor,
}) => (
  <div
    className={className}
    style={{ display: 'flex', flexWrap: 'wrap', gap: `${gap}px` }}
  >
    {items.map((item, index) => {
      // Section headers span full width
      if (item.isHeader) {
        return (
          <div key={item.id || `header-${index}`} style={{ flexBasis: '100%', height: 'auto' }}>
            {renderItem(item, index)}
          </div>
        );
      }

      const ar = Math.max(getAspectRatio(item, index), 0.3);
      const key = keyExtractor
        ? keyExtractor(item, index)
        : item.id || item._id || index;

      return (
        <div
          key={key}
          style={{
            flexGrow: ar,
            flexBasis: `${ar * targetRowHeight}px`,
            height: `${targetRowHeight}px`,
          }}
        >
          {renderItem(item, index)}
        </div>
      );
    })}
    {/* Spacer prevents last row from over-stretching */}
    <div style={{ flexGrow: 999, height: 0 }} aria-hidden="true" />
  </div>
);

export default JustifiedGrid;
